<template>
  <SectionLayout layout-empty custom-class="p-0 no-shadow" disabled-custom v-if="isExpiredTrial">
    <div class="bg-light1 border-radius dashboard__layout no-shadow d-flex flex-column align-items-center">
      <img :src="thumbnail" alt="" />
      <p class="heading-h3-20-semi text-center mt-4 expired-trial__title-first">{{firstTitle}}</p>
      <p class="heading-h3-20-semi text-light-high text-center expired-trial__title-second">{{secondTitle}}</p>
      <p class="typo-paragraph14 text-dark6 weight-400 text-center mt-2 expired-trial__description" v-html="description"></p>
      <router-link :to="{ name: 'Pricing' }" class="btn btn-primary text-light my-4 px-3 py-12px">
        {{ btnText }}
      </router-link>
    </div>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";
import { mapState } from "vuex";

export default {
  name: "ExpiredTrial",
  components: {
    SectionLayout
  },
  data: () => ({
    thumbnail: require("@/core/assets/new-dashboard/expired-trial.svg"),
  }),
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    totalPages() {
      if (this.shopInfo.totalPages) {
        return this.shopInfo.totalPages;
      } else {
        return false;
      }
    },
    isExpiredTrial() {
      return this.shopInfo.plan == "trial" && this.shopInfo.remainingDays <= 1 && this.shopInfo.totalPages;
    },
    description() {
      return  this.$t("dashboard.expiredTrialDescription", {
        page: this.totalPages.page,
        product: this.totalPages.product,
      });
    },
    firstTitle() {
      return this.$t("dashboard.expiredTrialTitleFirst");
    },
    secondTitle() {
      return this.$t("dashboard.expiredTrialTitleSecond");
    },
    btnText() {
      return this.$t("dashboard.expiredTrialPickPlan");
    }
  }
};
</script>

<style lang="scss">
.expired-trial {
  &__description {
    b {
      font-weight: 500;
      color: $textLightModeHigh;
    }
  }
  &__title {
    &-first {
      color: $accentRed400;
    }
  }
}
</style>
